import { useState } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { add_to_cart, decrease_cart } from "../../state/cartSlice";
import VegICO from "../../assets/Veg-Logo-2.png";
import NonVegICO from "../../assets/New-Non-Logo.png";

const Quants = styled.div`
	display: flex;
	flex-wrap: nowrap;
`;

const Inner = styled.div`
	display: flex;
	margin-top: -20px;
	z-index: 1;
	background: #fa7171;
	border-radius: 20px;
`;

const Image = styled.img`
	width: 25px;
	height: 25px;
`;

const Dish = ({ dish }) => {
	const dispatch = useDispatch();
	const [show, setShow] = useState(dish.description.length > 60);

	return (
		<div className="row fda_section_row bor">
			<div className="col-5 men">
				<img className="widt img_p" src={dish.image} alt={dish.name} />
				<Quants className="row">
					<Inner>
						<button
							type="button"
							className="btn btn-sm bttn4"
							onClick={() => dispatch(decrease_cart(dish))}
						>
							-
						</button>
						<span className="over2">{dish.quantity}</span>
						<button
							type="button"
							className="btn btn-sm bttn4"
							onClick={() => dispatch(add_to_cart(dish))}
						>
							+
						</button>
					</Inner>
				</Quants>
			</div>
			<div className="col-7 ">
				<span className="product_title">
					{dish.type === "Vegetarian" ? (
						<Image src={VegICO} alt={dish.type} />
					) : (
						<Image src={NonVegICO} alt={dish.type} />
					)}
				</span>
				<span className="product_title">{dish.name}</span>
				<span className="food_detail1">
					{show ? (
						<>
							{dish.description.substring(0, 60)}...
							<button
								className="btn btn-link readm"
								style={{ display: "inline" }}
								onClick={() => setShow(false)}
							>
								<b>Read more</b>
							</button>
						</>
					) : (
						dish.description
					)}
				</span>

				<span className="product_price">
					<i className="fa fa-inr"></i> {dish.price}
				</span>
			</div>
		</div>
	);
};

export default Dish;
